import { useAtomValue } from 'jotai';
import { createRunsheetAtom } from 'pages/title-workspaces/overview/runsheet-graph/atoms';
import { useMemo, useEffect } from 'react';
import { Timeline } from './timeline';
import { Loading, InlineNotification } from '@carbon/react';

import { Helmet } from 'react-helmet-async';
import { TitleWorkspaceResponse } from 'types/api-responses';
import styles from './page.module.scss';

const RunsheetTimelinePage = ({
  titleWorkspace,
}: {
  titleWorkspace: TitleWorkspaceResponse;
}) => {
  const queryHref = titleWorkspace.resources.queries.interpretations.href;

  const runsheetAtom = useMemo(() => {
    return createRunsheetAtom(queryHref);
  }, [queryHref]);

  const runsheet = useAtomValue(runsheetAtom);
  useEffect(() => {
    document.body.classList.add(`${styles.timelineContent}`);

    return () => {
      document.body.classList.remove(`${styles.timelineContent}`);
    };
  }, []);

  return runsheet ? (
    <>
      <Helmet>
        <title>{titleWorkspace.name} | Timeline | Insights</title>
      </Helmet>
      {runsheet.truncated && (
        <InlineNotification
          kind="warning"
          lowContrast
          hideCloseButton
          title="Partial view"
          subtitle="This workspace exceeds the searchable limit, so the timeline shows only part of the runsheet."
        />
      )}
      <Timeline runsheet={runsheet} />
    </>
  ) : (
    <Loading />
  );
};

export { RunsheetTimelinePage };
